import { Location, LocationSchema } from '@common/schemas/entities/location.schema';
import { z } from 'zod';

export { LocationSchema as LocationDTOSchema };
export type { Location as LocationDTO };

/**
 * Location Form schema (Domain-aligned for the editor).
 * Extends Common schema with UI-only fields like pendingFiles.
 */
export const LocationFormSchema = LocationSchema.omit({ audit: true }).extend({
  id: z.string().optional(),
  visualDescription: z.string().max(1500, "Visual description is too long (max 1500 characters)").optional(),
  pendingFiles: z.array(z.instanceof(File)).optional(),
}).passthrough();

export type LocationFormValues = z.infer<typeof LocationFormSchema>;
